
































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class UnsubscribeTemplate extends Vue {
  @Prop({ required: true }) unsubscribeEmail!: string;
  @Prop({ required: true }) unsubscribeType!: string;
  @Prop({ required: true }) notificationSettings!: any;
}
